import { render } from "./PrivacyPage.vue?vue&type=template&id=ced1b5b8&scoped=true&ts=true"
import script from "./PrivacyPage.vue?vue&type=script&lang=ts"
export * from "./PrivacyPage.vue?vue&type=script&lang=ts"

import "./PrivacyPage.vue?vue&type=style&index=0&id=ced1b5b8&scoped=true&lang=css"

import exportComponent from "/Users/pontustengroth/Desktop/git/shipd/apps/shipd-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ced1b5b8"]])

export default __exports__